import type { MailboxInfo } from 'owa-client-types';
import { getAccountScopeUserSettings } from '../selectors/getAccountScopeUserSettings';

export function isEdu(mailboxInfo: MailboxInfo): boolean {
    return !!getAccountScopeUserSettings(mailboxInfo).SessionSettings?.IsEdu;
}
